<template>
    <div>
        <div class="content-box first">
            <TitleTip>此处信息为认证信息，将会提供给第三方进行存证，用于签署合同、授权合约等</TitleTip>
            <RsStep class="full m-b-8" :active="0" :steps="['身份认证', '签署合同', '签署完成']"></RsStep>
            <el-form :model="formData" ref="formData" :rules="rules" label-width="160px" class="main-form label-left">
                <el-form-item prop="personName" label="姓名">
                    <el-input :disabled="isVerify" v-model="formData.personName"
                        placeholder="个人真实姓名，需要和证件上保持一致"></el-input>
                </el-form-item>
                <el-form-item prop="personMobile" label="认证手机号">
                    <el-input v-model="formData.personMobile" placeholder="请填写手机号" disabled></el-input>
                    <p style="color: #606266">
                        当前认证方式为{{ verifyType === 1 ? '微信人脸认证' : '手机号验证' }}可切换至
                        <el-button type="text" class="base underline"
                            @click="verifyType === 1 ? (verifyType = 2) : (verifyType = 1)">
                            {{ verifyType === 1 ? '手机号验证' : '微信人脸认证' }}
                        </el-button>
                    </p>
                </el-form-item>
                <el-form-item prop="personIdCard" label="证件编号">
                    <el-input :disabled="isVerify" v-model="formData.personIdCard" :maxlength="18" :minlength="18"
                        placeholder="和证件上保持一致" @input="handleIdNumInput"></el-input>
                </el-form-item>
                <el-form-item v-if="verifyType === 2" prop="idName" label="证件类型">
                    <el-select :disabled="isVerify" v-model="formData.idName">
                        <el-option :value="1" label="身份证"></el-option>
                        <!-- <el-option :value="2" label="护照"></el-option> -->
                    </el-select>
                </el-form-item>
                <el-form-item v-if="verifyType === 2" prop="personIdCardBackFile" label="证件正反面">
                    <div class="flex" style="justify-content: space-between">
                        <ImageUpload class="no-tips" :disabled="isVerify" :size="10"
                            :url.sync="formData.personIdCardBackFile" fixedNumber="4:3" accept="image/png,image/jpeg"
                            @onSuccess="handlepersonIdCardBackFileSuccess">
                            <div slot="tips">&nbsp;</div>
                        </ImageUpload>
                        <ImageUpload class="no-tips" :disabled="isVerify" :size="10" fixedNumber="4:3"
                            :url.sync="formData.personIdCardFrontFile" accept="image/png,image/jpeg"
                            @onSuccess="handlepersonIdCardFrontFileSuccess">
                            <div slot="tips">&nbsp;</div>
                        </ImageUpload>
                    </div>
                </el-form-item>
                <el-form-item prop="checked">
                    <el-checkbox v-model="checked">
                        我已阅读
                        <el-link class="link base" href="/help?key=privacyagreement"
                            target="_blank">《实名认证隐私协议》</el-link>
                    </el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-if="verifyType === 2" @click="onSubmit()"
                        :loading="btnLoading">进行认证</el-button>
                    <el-button type="primary" v-if="verifyType === 1" @click="faceVerify()"
                        :loading="btnLoading">开始人脸认证</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-dialog title="人脸识别认证" :visible.sync="dialogVisible" center :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="isDialogVisibleColse" append-to-body width="600px">
            <div class="qr-content">
                <p>
                    将要为
                    <b>{{ formData.personName }} ({{ showPersonMobile }})</b>
                    进行人脸识别
                    <br />
                    请使用微信扫一扫在手机完成认证
                </p>
                <div class="qrcode" ref="qrCode"></div>
            </div>
            <div slot="footer" class="qr-footer">
                <el-button v-if="!verifyLoading" type="primary" icon="el-icon-success" @click="goNext">去签约</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    import ImageUpload from '@/components/ImageUpload';
    export default {
        components: {
            ImageUpload,
        },
        data() {
            return {
                formData: {
                    idName: 1,
                },
                rules: {
                    personName: [{ required: true, message: '请输入名称' }],
                    personIdCard: [
                        {
                            required: true,
                            message: '请填写证件编号',
                            validator: (rule, value, callback) => {
                                const trimmed = value ? value.trim() : '';
                                callback(trimmed ? undefined : new Error(rule.message));
                            }
                        },
                        //禁止纯空格内容
                        {
                            pattern: /[^\s]/,
                            message: '证件编号不能全为空格'
                        }
                    ],
                    personIdCardFrontFile: [{ required: true, message: '请上传证件正面' }],
                    personIdCardBackFile: [{ required: true, message: '请上传证件背面' }],
                },
                btnLoading: false,
                dataLoading: false,
                dialogVisible: false,
                verifyLoading: false,
                checked: false,
                isDialogVisibleColse: true,
                qrcode: null,
                isVerifyStatus: true,
                verifyType: 2, // 1：人脸识别认证 2：手机号认证
            };
        },
        computed: {
            isVerify() {
                const { verify } = this.$store.state;
                return verify && verify.isVerify ? true : false;
            },
            qrUrl() {
                const { personName, personIdCard, personMobile, personIdCardFrontFile, personIdCardBackFile } = this.formData;
                const { sign, config } = this.$store.state;
                if (personName && personIdCard && personMobile && sign && config.cpHomeUrl)
                    return `${config.cpHomeUrl}/pages/contract/vefify/dzq/aliveVideo/aliveVideo?verifyName=${encodeURIComponent(
                        personName
                    )}&idNum=${personIdCard}&telephone=${personMobile}&sign=${sign}&from=pc&idPhoto=${encodeURIComponent(
                        personIdCardFrontFile
                    )}&idPhoto2=${encodeURIComponent(personIdCardBackFile)}`;
                return '';
            },
            showPersonMobile() {
                const { personMobile } = this.formData;
                if (!personMobile || personMobile.length !== 11) return '';
                return personMobile.substr(0, 3) + '****' + personMobile.substr(7);
            },
        },
        mounted() {
            this.$dzqToFdd(3);
            this.getInfo();
        },
        methods: {
            creatQrCode() {
                if (this.qrcode) {
                    this.qrcode.makeCode(this.qrUrl);
                } else {
                    this.qrcode = new QRCode(this.$refs.qrCode, {
                        text: this.qrUrl,
                        width: 200,
                        height: 200,
                        colorDark: '#5914ee',
                        colorLight: '#ffffff',
                        correctLevel: 3,
                    });
                }
            },
            handlepersonIdCardFrontFileSuccess() {
                if (this.formData.personIdCardFrontFile) {
                    // this.getIDCard();
                    this.$refs['formData'].clearValidate('personIdCardFrontFile');
                }
            },
            handlepersonIdCardBackFileSuccess() {
                if (this.formData.personIdCardBackFile) {
                    // this.getIDCard();
                    this.$refs['formData'].clearValidate('personIdCardBackFile');
                }
            },
            // 身份证读取
            async getIDCard() {
                const { personIdCardFrontFile, personIdCardBackFile } = this.formData;
                if (!personIdCardFrontFile || !personIdCardBackFile) return;
                const response = await this.$request({
                    url: '/letSign/idCardDiscern',
                    method: 'POST',
                    formData: false,
                    data: { backImage: personIdCardBackFile, frontImage: personIdCardFrontFile },
                });
                const { msg, state, result } = response.data;
                if (!state) return this.$message.error(msg || '');
                if (result.personName && result.personIdCard) {
                    this.formData.personName = result.personName;
                    this.formData.personIdCard = result.personIdCard;
                }
            },
            //获取详情
            getInfo() {
                this.dataLoading = true;
                this.$request({
                    url: '/org/view/get_identification_information',
                    method: 'post',
                })
                    .then((res) => {
                        const { state, msg, result } = res.data;
                        if (state == 1) {
                            this.formData = {
                                personMobile: result.telephone || '',
                                personIdCard: result.idNum || '',
                                personIdCardFrontFile: result.idPhoto || '',
                                personIdCardBackFile: result.idPhoto2 || '',
                                personName: result.verifyName || '',
                                idName: result.idName || 1,
                            };
                        } else {
                            this.$message.error(msg || '获取数据失败,请重试');
                        }
                    })
                    .catch(() => {
                        this.$message.error('获取数据失败,请重试');
                    })
                    .finally(() => {
                        this.dataLoading = false;
                    });
            },
            //提交
            onSubmit() {
                if (!this.checked) return this.$message.error('请仔细阅读《实名认证隐私协议》后，进行勾选');
                this.$refs['formData'].validate(async (valid) => {
                    if (valid) {
                        this.btnLoading = true;
                        this.$request({
                            url: '/letSign/personCert',
                            method: 'POST',
                            formData: false,
                            data: this.formData,
                        })
                            .then((res) => {
                                //处理成功回调
                                const { state, msg } = res.data;
                                if (state && state == 1) {
                                    this.$store.dispatch('getUserInfo');
                                    this.$contractRouter('/manage/contract/verify/fdd/step/2');
                                } else {
                                    return this.$message.error(msg || '操作失败');
                                }
                            })
                            .finally(() => {
                                this.btnLoading = false;
                            });
                    }
                });
            },
            // 人脸识别认证
            faceVerify() {
                const { personName, personIdCard } = this.formData;
                if (!this.checked) return this.$message.error('请仔细阅读《实名认证隐私协议》后，进行勾选');
                if (!personName || !personIdCard) return this.$message.error('请完善姓名和证件编号后进行人脸识别');

                this.dialogVisible = true;
                this.verifyLoading = true;
                this.$nextTick(() => {
                    this.creatQrCode();
                });
                if (this.isVerifyStatus) {
                    this.isVerifyStatus = false;
                    this.verifyStatus();
                }
            },
            goNext() {
                this.$store.dispatch('getUserInfo');
                this.$contractRouter('/manage/contract/verify/fdd/step/2');
            },
            // 手机号认证
            async verifyStatus() {
                const response = await this.$request({
                    url: '/letSign/verifyStatus',
                    method: 'POST',
                });
                const { msg, state, result } = response.data;
                if (!state) return this.$message.error(msg || '');
                if (result === 2) {
                    this.$message.success('认证成功');
                    this.verifyLoading = false;
                } else if (result === 3) {
                    this.$message.error('人脸识别认证失败，请重新确认个人信息进行尝试');
                } else {
                    const timeOut = setTimeout(() => {
                        clearTimeout(timeOut);
                        this.verifyStatus();
                    }, 2000);
                }
            },
            handleIdNumInput(value) {
                // 移除所有空格（包括中间空格）
                const cleanedValue = value.replace(/\s+/g, '');
                this.formData.personIdCard = cleanedValue;
                this.$nextTick(() => {
                    this.$refs.formData.validateField('personIdCard');
                });
            }
        },
    };
</script>
<style lang="scss">
    .qr-content {
        text-align: center;

        b {
            color: #333;
        }

        .qrcode {
            margin-top: 20px;
            text-align: center;
            display: inline-block;
        }
    }

    .el-form-item__content {
        p b {
            color: #333;
        }
    }
</style>
